/**
 * Returns a Promise that resolves after the given number of milliseconds (default: 1000ms).
 * Useful for introducing deliberate delays in async flows.
 */
export const sleep = async (msTimeout = 1000) => {
    // eslint-disable-next-line no-promise-executor-return
    return new Promise((r) => setTimeout(r, msTimeout));
};
